;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import {
    assetFragment,
    ctaFragment,
    iconFragment,
    linkFragment,
} from 'lib/graphql/fragments';

import BlockSectionHeading from './BlockSectionHeading';

const query = /* GraphQL */ `
    ${assetFragment}
    ${ctaFragment}
    ${linkFragment}
    ${iconFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockEyebrow(preview: $preview, id: $id) {
            __typename
            anchorId
            icon {
                ... on Icon {
                    ...Icon
                }
            }
            eyebrow
            richHeadline {
                json
            }
            flushTop
            flushBottom
            copy: richText {
                json
                links {
                    entries {
                        hyperlink {
                            sys {
                                id
                            }
                            ...EntryLink
                        }
                    }
                }
            }
            cta {
                ... on Cta {
                    ...CTA
                }
            }
            theme
            textAlign
            backgroundColor: backgroundColorCustom
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockEyebrow },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });
    return blockEyebrow;
}

const BlockSectionHeadingServer = async ({ id, firstBlock }) => {
    const block = await fetchBlock(id);
    return <BlockSectionHeading {...block} firstBlock={firstBlock} />;
};

export default BlockSectionHeadingServer;
